import axiosInstance from "../configs/axios/axiosInstance";
import { LocalFileLogResponse, LocalFileResponse, NewLocalFileRequest } from "../pages/configurations/localFiles/localFiles.types";
import { ApiValueResponse } from "../types/apiResponse";

const LocalfilesServices = {

    getLocalFilesList: async (): Promise<ApiValueResponse<LocalFileResponse>> => {
        const response = await axiosInstance.get<ApiValueResponse<LocalFileResponse>>('LocalFiles/GetLocalFiles');
        return response.data;
    },

    getLocalFilesLogs: async (userId: string): Promise<ApiValueResponse<LocalFileLogResponse>> => {
        const params = { userId };
        const response = await axiosInstance.get<ApiValueResponse<LocalFileLogResponse>>('LocalFiles/GetLocalFilesLogs', { params: params });
        return response.data;
    },

    addLocalFile: async (payload: FormData): Promise<any> => {
        const response = await axiosInstance.post<any>('LocalFiles/UploadLocalFile', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    newLocalFile: async (payload: FormData): Promise<any> => {
        const response = await axiosInstance.post<any>('LocalFiles/AddLocalFile', payload);
        return response.data;
    },

    updateLocalFile: async (payload: FormData): Promise<any> => {
        const response = await axiosInstance.put<any>('LocalFiles/UpdateLocalFile', payload);
        return response.data;
    }
};

export default LocalfilesServices;
